import React from 'react'
import { Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

interface BackLinkProps {
  /** `Back to <list>`. */
  label: string
  onClick: () => void
}

/** The way back from a detail or sub-page to its list. The page wires the
 *  navigation; this only draws it. */
const BackLink: React.FC<BackLinkProps> = ({ label, onClick }) => (
  <Button size="small" color="info" startIcon={<ArrowBackIcon />} onClick={onClick}>
    {label}
  </Button>
)

export default BackLink
